<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.874.006C2.27.611.604 3.174 1.081 5.843 1.511 8.252 3.575 10 5.987 10A4.957 4.957 0 0 0 9.95 8.014a.243.243 0 0 0-.274-.377c-.237.089-.48.155-.725.2a4.251 4.251 0 0 1-3.24-.713 4.368 4.368 0 0 1-1.796-2.83A4.451 4.451 0 0 1 5.099.418a.244.244 0 0 0 .04-.291.24.24 0 0 0-.265-.12z"
      fill="#A9B7D1"
      fill-rule="evenodd"
    />
  </svg>
</template>
